export default "__VITE_ASSET__BSz46m0L__"